module.exports = __webpack_public_path__ + "static/media/blogpost4.db1f5b9f.jpg";